// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static-dist/" + {"538":"recorder","983":"profiler"}[chunkId] + "/js/" + {"538":"recorder","983":"profiler"}[chunkId] + ".bundle." + {"538":"56e915ff6e52e839ce65","983":"1418590eef69d1f389d6"}[chunkId] + ".js";
};